<template>
  <div ref="sidebar" id="sidebar">
    <div class="sidebar_content sidebar_head">
      <feather-icon
        @click="hiddenModal()"
        icon="XIcon"
        svgClasses="h-6 w-6 head_icon"
      />
      <h1 class="head_title">Publicación {{ orderDetail.id }}</h1>
    </div>
    <div class="sidebar_content sidebar_body">
      <div class="body_title-wrapper">
        <p class="title_text">Detalle</p>
      </div>
      <div class="body_center-wrapper">
        <p class="center_image">Imagen</p>
        <p class="center_text">
          {{ orderDetail.order_items[0].item.title }}
        </p>
      </div>
      <strong class="font-medium"
            >x {{ orderDetail.order_items[0].quantity }}</strong
          >
      <hr class="divider" />
      <div class="body_footer">
        <div class="footer__text-wrapper">
          <p class="footer_text-left">Valor</p>
          <p class="footer_text-rigth">$ {{ orderDetail.order_items[0].unit_price }}</p>
        </div>
      </div>
    </div>
    <div class="sidebar_content sidebar_body">
      <div class="body_title-wrapper">
        <p class="title_text">Comprador</p>
      </div>
      <div class="body_footer">
        <div class="footer__text-wrapper footer__text--no-bold">
          <p class="footer_text-left">{{ orderDetail.buyer.first_name }}</p>
          <p class="footer_text-rigth">{{ orderDetail.buyer.last_name }}</p>
        </div>
      </div>
    </div>
    <div class="sidebar_content sidebar_body">
      <div class="body_title-wrapper">
        <p class="title_text">Modo de envio</p>
      </div>
      <div class="body_footer">
        <div class="footer__text-wrapper footer__text--no-bold">
          <p class="footer_text-left">{{ orderDetail.shipment_data.mode | translateShipmentMode }}</p>
        </div>
      </div>
    </div>
    <div class="sidebar_content sidebar_body">
      <div class="body_title-wrapper">
          <p class="title_text">Status</p>
      </div>
      <div class="body_footer">
          <div class="footer__text-wrapper footer__text--no-bold">
          <p class="footer_text-left">Status Mercado Libre</p>
          <p class="footer_text-rigth footer_text--mercado-libre">{{ orderDetail.shipment_data.status | translateStatusMeli }}</p>
          </div>
          <div class="footer__text-wrapper footer__text--no-bold">
          <p class="footer_text-left">Status Cruz del Sur</p>
          <p class="footer_text-rigth footer_text--cruz-del-sur">{{ orderDetail.cds_status }}</p>
          </div>
          <div class="footer__text-wrapper footer__text--no-bold">
          <p class="footer_text-left">NIC:</p>
          <p class="footer_text-rigth">{{ orderDetail.cds_nic }}</p>
          </div>
      </div>
    </div>
    <div class="sidebar_content sidebar_body" v-show="orderDetail.shipment_data">
      <div class="body_title-wrapper">
        <p class="title_text">Dirección</p>
      </div>
      <div class="body_footer">
        <div class="footer__text-wrapper footer__text--no-bold">
          <p class="footer_text-left">Nombre:</p>
          <p class="footer_text-rigth">{{ orderDetail.shipment_data.receiver_address.receiver_name }}</p>
        </div>
        <div class="footer__text-wrapper footer__text--no-bold">
          <p class="footer_text-left">Calle:</p>
          <p class="footer_text-rigth">{{ orderDetail.buyer_street ? orderDetail.buyer_street: orderDetail.shipment_data.receiver_address.street_name }}, 
            {{ orderDetail.shipment_data.receiver_address.street_number }}</p>
        </div>
        <div class="footer__text-wrapper footer__text--no-bold">
          <p class="footer_text-left">Localidad:</p>
          <p class="footer_text-rigth">{{ orderDetail.shipment_data.receiver_address.city.name }}, 
            {{ orderDetail.buyer_city ? orderDetail.buyer_city: orderDetail.shipment_data.receiver_address.state.name }}</p>
        </div>
        <div class="footer__text-wrapper footer__text--no-bold">
          <p class="footer_text-left">CP:</p>
          <p class="footer_text-rigth">{{ orderDetail.buyer_zip ? orderDetail.buyer_zip: orderDetail.shipment_data.receiver_address.zip_code }}</p>
        </div>
        <div class="footer__text-wrapper footer__text--no-bold">
          <p class="footer_text-left">Teléfono</p>
          <p class="footer_text-rigth">{{ orderDetail.buyer_phone ? orderDetail.buyer_phone: orderDetail.shipment_data.receiver_address.receiver_phone }}</p>
        </div>
        <div class="footer__text-wrapper footer__text--no-bold" v-if="orderDetail.buyer_email">
          <p class="footer_text-left">Correo</p>
          <p class="footer_text-rigth">{{ orderDetail.buyer_email }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderDetails",
  props: {
    orderDetail: Object,
  },
  filters: {
    translateShipmentMode(mode) {
      let modesMap = {
        not_specified: "Acuerdo con el vendedor",
        custom: "Envio Custom",
        me1: "Mercado Envíos 1",
        me2: "Mercado Envíos 2",
      };

      return modesMap[mode] ? modesMap[mode] : "";
    },
    translateStatusMeli(status) {
      let modesMap = {
        to_be_agreed: "Acordado con el vendedor",
        pending: "Pendiente",
        handling: "Recibido",
        ready_to_ship: "Listo para enviar",
        shipped: "Enviado",
        delivered: "Entregado",
        not_delivered: "No Entregado",
        cancelled: "Cancelado"
      };

      return modesMap[status] ? modesMap[status] : "";
    },
  },
  data() {
    return {
      sidebar: null,
    };
  },
  mounted() {
    document.getElementById("sidebar").classList.add("show");
  },
  methods: {
    hiddenModal() {
      document.getElementById("sidebar").classList.remove("show");
      this.$emit("orderDetail", this.orderDetail);
    },
  },
};
</script>